<template>
  <w-datepicker class="datepicker" :title="title" :model="model" />
</template>

<script>
import WDatepicker from '@witkac/bootstrap4-components/src/components/datepicker.vue';

// @vuese
// Input z wyborem daty
// @group Components
export default {
  name: 'Form-Datepicker',
  components: {
    WDatepicker
  },
  props: {
    // model
    model: {
      type: Object,
      required: true
    },
    // tytuł
    title: {
      type: String,
      required: false,
      default: undefined
    }
  }
};
</script>

